import { upsert } from '../../helpers'
import { SET_POLL_FEATURED_FLAG_SUCCESS } from '../../stores/pollsStore'

export const CLEAR_FEATURED_POLLS = 'opinary/CLEAR_FEATURED_POLLS'
export const FETCH_FEATURED_POLLS = 'opinary/FETCH_FEATURED_POLLS'
export const FETCH_FEATURED_POLLS_SUCCESS =
  'opinary/FETCH_FEATURED_POLLS_SUCCESS'
export const FETCH_FEATURED_POLLS_ERROR = 'opinary/FETCH_FEATURED_POLLS_ERROR'

export function clearFeaturedPolls() {
  return {
    type: CLEAR_FEATURED_POLLS,
  }
}

export function fetchFeaturedPolls() {
  return {
    type: FETCH_FEATURED_POLLS,
  }
}

export function fetchFeaturedPollsSuccess(polls) {
  return {
    type: FETCH_FEATURED_POLLS_SUCCESS,
    payload: {
      polls,
    },
  }
}

export function fetchFeaturedPollsError(error) {
  return {
    type: FETCH_FEATURED_POLLS_ERROR,
    payload: {
      error,
    },
  }
}

// Selectors

export function selectFeaturedPolls(rootState: RootState): Array<Poll> {
  if (
    rootState.polls &&
    rootState.polls.featured &&
    rootState.polls.featured.polls
  ) {
    return Object.keys(rootState.polls.featured.polls).map(
      pollId => rootState.polls.featured.polls[pollId]
    )
  }

  return []
}

const initialState = {
  polls: {},
  loading: false,
  error: false,
}

export default function reducer(
  state = initialState,
  { type, payload, pollId }
) {
  switch (type) {
    case CLEAR_FEATURED_POLLS:
      return initialState
    case FETCH_FEATURED_POLLS:
      return {
        polls: state.polls,
        loading: true,
        error: false,
      }
    case FETCH_FEATURED_POLLS_SUCCESS:
      const polls = payload.polls.reduce(
        (polls, poll) => ({ ...polls, [poll.id]: poll }),
        {}
      )
      return {
        polls: upsert(state.polls, polls),
        loading: false,
        error: false,
      }
    case FETCH_FEATURED_POLLS_ERROR:
      return {
        polls: null,
        loading: false,
        error: payload.error,
      }
    case SET_POLL_FEATURED_FLAG_SUCCESS:
      let featured = Object.assign({}, state.polls)
      if (featured[pollId]) {
        delete featured[pollId]
      }
      return {
        ...state,
        polls: featured,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/polls/featured.js